var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEyeOpen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 128,
    height: 100.238,
    viewBox: "0 0 128 100.238",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1",
    "data-name": "Group 1",
    transform: "translate(-748 -460)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "eye-close",
    transform: "translate(748 446.119)",
    opacity: 0.001
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1",
    "data-name": "Path 1",
    d: "M20.1,90.429,36.815,73.716A28.871,28.871,0,0,1,73.7,36.829L85.115,25.417A70.368,70.368,0,0,0,.258,62.853a2.744,2.744,0,0,0,0,2.321A70.584,70.584,0,0,0,20.1,90.429Z",
    fill: "#b2b2c9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2",
    "data-name": "Path 2",
    d: "M107.9,37.584,91.185,54.3A28.871,28.871,0,0,1,54.3,91.185L42.885,102.6A70.368,70.368,0,0,0,127.742,65.16a2.738,2.738,0,0,0,0-2.321A70.57,70.57,0,0,0,107.9,37.584Z",
    fill: "#b2b2c9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3",
    "data-name": "Path 3",
    d: "M64.007,82.478A18.468,18.468,0,0,0,82.478,64.007c0-.316-.014-.646-.028-.961l-19.4,19.4C63.361,82.464,63.677,82.478,64.007,82.478Z",
    fill: "#b2b2c9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4",
    "data-name": "Path 4",
    d: "M64.007,45.55A18.468,18.468,0,0,0,45.536,64.021c0,.316.014.645.028.961l19.4-19.405C64.639,45.55,64.323,45.55,64.007,45.55Z",
    fill: "#b2b2c9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5",
    "data-name": "Path 5",
    d: "M24.565,93.726,15.886,102.4a6.87,6.87,0,0,0,9.723,9.709L37.2,100.523,49.038,88.686l7.7-7.7L81,56.728l7.7-7.7,14.75-14.749,8.679-8.679a6.87,6.87,0,0,0-9.723-9.709L90.814,27.477,78.976,39.315l-7.7,7.7L47.019,71.272l-7.7,7.7Z",
    fill: "#b2b2c9"
  })), /*#__PURE__*/React.createElement("g", {
    id: "eye-open",
    transform: "translate(748 445.82)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6",
    "data-name": "Path 6",
    d: "M64,22.18A70.272,70.272,0,0,0,.257,62.84a2.743,2.743,0,0,0,0,2.321,70.3,70.3,0,0,0,127.486,0,2.745,2.745,0,0,0,0-2.321A70.273,70.273,0,0,0,64,22.18Zm0,70.677A28.85,28.85,0,1,1,92.85,64.007,28.848,28.848,0,0,1,64,92.857Z",
    fill: "#b2b2c9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7",
    "data-name": "Path 7",
    d: "M64,82.462A18.469,18.469,0,1,0,45.531,63.993,18.469,18.469,0,0,0,64,82.462Z",
    fill: "#b2b2c9"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeOpen);
export default __webpack_public_path__ + "static/media/eye-open.9cf0158bbce4a0937e06b50a64ecb522.svg";
export { ForwardRef as ReactComponent };